// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ComplianceUserMetricSchema = z.object({
  user_id: z.number().int().describe("User ID"),
  name: z.coerce.string().describe("Display name (falls back to email if blank)"),
  email: z.coerce.string().describe("User email"),
  weekly_capacity_hours: z.number().min(0).describe("Configured weekly hour target for this user"),
  total_hours: z.number().min(0).describe("Total hours logged in the window across all sources"),
  ai_hours: z.number().min(0).describe("Hours logged via AutoSheet AI (created_from = AI)"),
  automation_rate: z.number().min(0).max(1).describe("AutoSheet automation rate: ai_hours / total_hours, 0–1"),
  last_seen_at: z.coerce.string().describe("ISO8601 timestamp of most recent Timely app sync. Null if never seen.").nullish(),
  memory_state: z.coerce.string().describe("Derived state: 'on' (≤24h), 'stale' (≤30d), 'off' (>30d or never)"),
  last_hours_logged_at: z.coerce.string().describe("ISO8601 timestamp of the user's most recent Hour entry, regardless of source. Null if never.").nullish(),
  memory_active_days_in_window: z.number().int().min(0).describe("Count of distinct calendar days in [from, to] on which the user had any MemoryAppLog activity."),
  logged_days_in_window: z.number().int().min(0).describe("Count of distinct Hour.day values in [from, to] for which the user has at least one Hour, across any created_from source."),
});
